import { useContext } from "react";
import useSWR from "swr";
import { ToastContext } from "../context/ToastContext";
import { ChasablesContext, ChasableSignalRContext as SignalRContext } from "../context/ChasablesContext";
import { ChasableDetailsModel } from "../models/ChasableModels";

type Options = {
  onSuccess?: (data?: ChasableDetailsModel) => void;
};

export const useChasable = (invoiceId: string | null | undefined, external: boolean, options: Options = {}) => {
  const { isLoading: isConnecting } = useContext(ChasablesContext);
  const { showToast } = useContext(ToastContext);

  const { data, isLoading, error, mutate } = useSWR(
    invoiceId && !isConnecting ? ["GetChasable", invoiceId] : null,
    () => {
      if (external) {
        return SignalRContext.connection?.invoke<ChasableDetailsModel>("GetExternalChasable", invoiceId, null);
      } else {
        return SignalRContext.connection?.invoke<ChasableDetailsModel>("GetChasable", invoiceId);
      }
    },
    {
      onSuccess(data) {
        options.onSuccess?.(data);
      },
      onError: () => {
        showToast("Failed to get the invoice, please try again later", "error");
      },
    }
  );

  return {
    chasable: data,
    isLoading,
    isError: !!error,
    refetchChasable: () => mutate(),
  };
};
